import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import classnames from 'classnames';
import { Record } from 'immutable';

import { translate as t } from '../../lib/I18n';
import { baseModalScrollTo } from '../general/BaseModal';
import Address from '../../records/customer/Address';
import FeatureFlagStore from '../../stores/FeatureFlagStore';

import AddressLineOne from '../payment/AddressLineOne';
import AddressLineTwo from '../payment/AddressLineTwo';
import AddressLineThree from '../payment/AddressLineThree';
import TownCity from '../payment/TownCity';
import Postcode from '../payment/Postcode';
import Country from '../payment/Country';
import PostCodeLookUp from '../customer/PostCodeLookUp';


export default class CustomerPostalAddress extends React.PureComponent {
    static propTypes = {
        label: PropTypes.string.isRequired,
        outsideLabel: PropTypes.bool,
        validation: PropTypes.object,
        onSelectAddress: PropTypes.func.isRequired,
        visited: PropTypes.bool,
        form: PropTypes.instanceOf(Record).isRequired,
        onChange: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        alwaysShowAddressFields: PropTypes.bool,
        index: PropTypes.number,
    };

    static defaultProps = {
        validation: null,
        visited: false,
        disabled: false,
        alwaysShowAddressFields: false,
        index: null,
    };

    state = {
        showAddressFields: !FeatureFlagStore.get('enablePostCodeLookUp')
    };

    _handleAddressLookup = () => {
        _.defer(() => {
            const addressSelect = document.querySelector('.otrl-postal-address-select');
            const smartcardRow = document.querySelector('.register-smartcard-top-row');
            if (addressSelect && smartcardRow) {
                const addressSelectTop = addressSelect.getBoundingClientRect().top;
                const registerTopRowTop = smartcardRow.getBoundingClientRect().top;
                baseModalScrollTo({ top: addressSelectTop - registerTopRowTop });
            }
        });
    }

    _handleSelectAddress = (address) => {
        const { index } = this.props;
        this.setState({ showAddressFields: true });

        // Wait until React displays additional address fields between the address selector
        // and the date of birth drop downs.
        _.defer(() => {
            const dateOfBirthSelect = document.querySelector('.date-of-birth__select');
            const smartcardRow = document.querySelector('.register-smartcard-top-row');
            if (dateOfBirthSelect && smartcardRow) {
                const dateOfBirthTop = dateOfBirthSelect.getBoundingClientRect().top;
                const registerTopRowTop = smartcardRow.getBoundingClientRect().top;
                baseModalScrollTo({ top: dateOfBirthTop - registerTopRowTop });
            }
        });

        if (index >= 0 && index !== null) {
            this.props.onSelectAddress(address, null, index);
        } else {
            this.props.onSelectAddress(address);
        }
    };

    _handleToggleShowAddress = () => {
        this.setState({ showAddressFields: !this.state.showAddressFields });
    };

    _handleClearAddress = () => {
        this.props.onSelectAddress(new Address());
    };

    render() {
        const { showAddressFields } = this.state;
        const { label, form, alwaysShowAddressFields, outsideLabel } = this.props;
        return (
            <div className="postal-address">
                <Col md={12}>
                    <p className="label">{t(label)}</p>
                </Col>

                <Col md={12}>
                    <PostCodeLookUp country={form.get('country')}
                        outsideLabel={outsideLabel}
                        onFoundAddressList={this._handleAddressLookup}
                        onSelectAddress={this._handleSelectAddress}
                        cols={{ xs: 12, md: 6 }} />
                </Col>

                <div className="clearfix">
                    <Col md={6} className={classnames('manual-address-col', { 'manual-address-col--no-margin': showAddressFields || alwaysShowAddressFields })}>
                        {(!showAddressFields && !alwaysShowAddressFields) &&
                            <div>
                                <Button className='btn-link manual-address-btn postal-address__manual-button' onClick={this._handleToggleShowAddress}>
                                    {t('address.enterManually')}
                                </Button>
                            </div>
                        }
                    </Col>

                    <Col md={6} className='clear-address-col'>
                        {(showAddressFields || alwaysShowAddressFields) &&
                            <Button bsStyle="default" className="btn-default clear" onClick={this._handleClearAddress}>
                                {t('address.clearAddress')}
                            </Button>
                        }
                    </Col>
                </div>

                {(showAddressFields || alwaysShowAddressFields) &&
                    <div>
                        <Col md={6} xs={12}>
                            <AddressLineOne {...this.props} required />
                        </Col>

                        <Col md={6} xs={12}>
                            <AddressLineTwo {...this.props} />
                        </Col>

                        <Col md={6} xs={12}>
                            <AddressLineThree {...this.props} />
                        </Col>

                        <Col md={6} xs={12}>
                            <TownCity {...this.props} required />
                        </Col>

                        <Col md={6} xs={12}>
                            <Postcode {...this.props} required />
                        </Col>

                        <Col md={6} xs={12}>
                            <Country {...this.props} disabled />
                        </Col>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/customer/PostalAddress.js